import { useLocation } from "react-router-dom";
import { UserMenu } from "./UserMenu";
import { useGameStore } from "../store/gameStore";

export function GlobalHeader() {
  const { displayName, sessionId } = useGameStore();
  const location = useLocation();

  // Don't show on admin or settings page (they have their own headers)
  if (location.pathname === "/admin" || location.pathname === "/settings") {
    return null;
  }

  // Don't show on RoomList (it has its own UserMenu in header)
  // RoomList is shown when sessionId is null
  if (!sessionId) {
    return null;
  }

  // Only show if user has a display name (is logged in)
  if (!displayName) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50">
      <UserMenu />
    </div>
  );
}
